module.exports = __webpack_public_path__ + "img/importImgIco.dfa77e5c.svg";